(function () {
  window.BrownieMotherDay = window.BrownieMotherDay || {};
  const BrownieMotherDay = window.BrownieMotherDay;

  // ── LANDING ──────────────────────────────────────────────────────────────
  BrownieMotherDay.initLanding = function (sectionId) {
    document
      .querySelectorAll('[data-section-id="' + sectionId + '"] a[href="#mdc-card-creator"]')
      .forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('mothers-day:open'));
        });
      });

    document
      .querySelectorAll('[data-section-id="' + sectionId + '"] a[data-action="inspire"]')
      .forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('mothers-day:inspire'));
        });
      });
  };

  // ── CARD CREATOR ─────────────────────────────────────────────────────────
  BrownieMotherDay.initCardCreator = function (id, saveEndpoint) {
    const mdcEl        = document.getElementById('mdc-card-creator');
    const fondosEl     = document.getElementById('mdc-fondos-' + id);
    const fondoUi      = document.getElementById('mdc-fondo-ui-' + id);
    const fondoClose   = document.getElementById('mdc-fondo-close-' + id);
    const counter      = document.getElementById('mdc-counter-' + id);
    const elegirBtn    = document.getElementById('mdc-elegir-' + id);
    const editor       = document.getElementById('mdc-editor-' + id);
    const editorBg     = document.getElementById('mdc-editor-bg-' + id);
    const editorBgCss  = document.getElementById('mdc-editor-bg-css-' + id);
    const editorClose  = document.getElementById('mdc-editor-close-' + id);
    const cardEl       = document.getElementById('mdc-card-' + id);
    const cardText     = document.getElementById('mdc-card-text-' + id);
    const cardWrapEl   = mdcEl ? mdcEl.querySelector('.mdc__card-wrap') : null;
    const stickerLayer = document.getElementById('mdc-sticker-layer-' + id);
    const stickerTrash = document.getElementById('mdc-sticker-trash-' + id);
    const compartir    = document.getElementById('mdc-compartir-' + id);
    const shareOverlay = document.getElementById('mdc-share-overlay-' + id);
    const fontList     = document.getElementById('mdc-font-list-' + id);
    const stickerGrid  = document.getElementById('mdc-sticker-grid-' + id);
    const textSiguiente= document.getElementById('mdc-text-siguiente-' + id);

    // Voice elements
    const voicePanelEl   = document.getElementById('mdc-voice-panel-' + id);
    const recordBtn      = document.getElementById('mdc-record-btn-' + id);
    const timerEl        = document.getElementById('mdc-timer-' + id);
    const timerDisplayEl = document.getElementById('mdc-timer-display-' + id);
    const waveform       = document.getElementById('mdc-waveform-' + id);
    const voiceDeleteBtn = document.getElementById('mdc-voice-delete-' + id);
    const voicePlayBtn   = document.getElementById('mdc-voice-play-' + id);
    const voiceConfirmBtn= document.getElementById('mdc-voice-confirm-' + id);

    const panels = {
      text:    document.getElementById('mdc-panel-text-' + id),
      sticker: document.getElementById('mdc-panel-sticker-' + id),
      voice:   document.getElementById('mdc-panel-voice-' + id)
    };

    const toolBtns = {
      text:    document.getElementById('mdc-tool-text-' + id),
      sticker: document.getElementById('mdc-tool-sticker-' + id),
      voice:   document.getElementById('mdc-tool-voice-' + id)
    };

    function focusAtEnd(el) {
      el.focus();
      const range = document.createRange();
      range.selectNodeContents(el);
      range.collapse(false);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    }

    // ── STATE ──
    let currentFondo = 1;
    const totalFondos    = fondosEl ? fondosEl.querySelectorAll('.mdc__fondo').length : 5;
    let currentFont    = "'Cormorant Garamond', serif";
    let currentSize    = 16;
    let mediaRecorder  = null;
    let audioChunks    = [];
    let recordTimer    = null;
    let recordSeconds  = 0;
    let audioBlob      = null;
    let waveInterval   = null;
    let audioPlayer    = null;

    // ── FONDO SRC POR DISPOSITIVO ───────────────────────────────────────────
    // En el selector mobile (mdc__fondos) las imágenes usan image_mobile por defecto.
    // En iPad (768-1023px) cargamos la imagen tablet desde data-tablet-src.
    function updateFondoSrcs() {
      if (!fondosEl) return;
      const w = window.innerWidth;
      fondosEl.querySelectorAll('.mdc__fondo').forEach(function (fondo) {
        const img = fondo.querySelector('img');
        if (!img) return;
        const tabletSrc  = fondo.dataset.tabletSrc;
        const desktopSrc = fondo.dataset.desktopSrc;
        const best = (w >= 1280 && desktopSrc) ? desktopSrc
          : (w >= 768  && tabletSrc)  ? tabletSrc
            : null;
        if (best && img.src !== best) img.src = best;
      });
    }

    // ── OVERLAY OPEN/CLOSE ──────────────────────────────────────────────────
    let _mdcScrollY = 0;

    function openMdc() {
      if (!mdcEl) return;
      _mdcScrollY = window.scrollY || window.pageYOffset;
      document.body.style.position = 'fixed';
      document.body.style.top      = '-' + _mdcScrollY + 'px';
      document.body.style.width    = '100%';
      document.body.style.overflow = 'hidden';
      document.body.classList.add('mdc-open');
      mdcEl.classList.add('is-open');
      updateFondoSrcs();
    }

    function closeMdc() {
      document.body.style.position = '';
      document.body.style.top      = '';
      document.body.style.width    = '';
      document.body.style.overflow = '';
      document.body.classList.remove('mdc-open');
      window.scrollTo(0, _mdcScrollY);
      if (mdcEl) mdcEl.classList.remove('is-open');
      if (editor) editor.classList.remove('is-active');
      if (fondoUi) fondoUi.style.display = '';
      if (inspireViewEl) inspireViewEl.classList.remove('is-open');
      stopRecording();
    }

    document.addEventListener('mothers-day:open', openMdc);

    if (fondoClose) fondoClose.addEventListener('click', closeMdc);

    // ── STEP 1: scroll tracking ──────────────────────────────────────────────
    if (fondosEl) {
      fondosEl.addEventListener('scroll', function () {
        const h = fondosEl.clientHeight || window.innerHeight;
        let idx = Math.round(fondosEl.scrollTop / h) + 1;
        idx = Math.max(1, Math.min(idx, totalFondos));
        if (idx !== currentFondo) {
          currentFondo = idx;
          if (counter) counter.textContent = currentFondo + ' / ' + totalFondos;
        }
      });
    }

    // ── ELEGIR → editor ──────────────────────────────────────────────────────
    if (elegirBtn) elegirBtn.addEventListener('click', openEditor);

    function openEditor() {
      const fondoEls = fondosEl ? fondosEl.querySelectorAll('.mdc__fondo') : [];
      const selected = fondoEls[currentFondo - 1];

      if (selected) {
        const img = selected.querySelector('img');
        if (img) {
          const w = window.innerWidth;
          const tabletSrc  = selected.dataset.tabletSrc;
          const desktopSrc = selected.dataset.desktopSrc;
          const baseSrc = (w >= 1280 && desktopSrc) ? desktopSrc : (w >= 768 && tabletSrc) ? tabletSrc : img.src;
          // Add cache-bust so CORS response is cached separately from non-CORS page cache
          const corsSrc = baseSrc + (baseSrc.indexOf('?') >= 0 ? '&' : '?') + '_cors=1';
          const newImg = document.createElement('img');
          newImg.crossOrigin = 'anonymous';
          newImg.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;';
          newImg.src = corsSrc;
          // Preserve editorBgCss – only remove previous bg imgs
          editorBg.querySelectorAll('img').forEach(function (i) { i.remove(); });
          if (!editorBg.contains(editorBgCss)) editorBg.appendChild(editorBgCss);
          editorBgCss.style.background = '';
          editorBgCss.className = 'mdc__editor-bg--css';
          editorBg.appendChild(newImg);
        } else {
          const classes = selected.className.split(' ');
          const bgClass = classes.find(function (c) { return c.startsWith('mdc__fondo--') && c !== 'mdc__fondo'; });
          editorBg.querySelectorAll('img').forEach(function (i) { i.remove(); });
          if (!editorBg.contains(editorBgCss)) editorBg.appendChild(editorBgCss);
          editorBgCss.className = 'mdc__editor-bg--css ' + (bgClass || '');
        }
      }

      editor.classList.add('is-active');
      if (fondoUi) fondoUi.style.display = 'none';
      closeAllPanels();
      // Show tool icons, hide card – user must tap to start writing
      if (toolsEl)    toolsEl.style.display = '';
      if (cardWrapEl) cardWrapEl.style.display = 'none';
    }

    function closeEditor() {
      if (editor) editor.classList.remove('is-active');
      if (fondoUi) fondoUi.style.display = '';
      stopRecording();
      // Reset mobile step state
      if (textSiguiente) textSiguiente.classList.remove('is-visible');
      if (toolsEl)    toolsEl.style.display = 'none';
      if (cardWrapEl) cardWrapEl.style.display = 'none';
      closeAllPanels();
    }

    if (editorClose) editorClose.addEventListener('click', closeEditor);

    function closeAllPanels() {
      Object.keys(toolBtns).forEach(function (k) {
        if (toolBtns[k]) toolBtns[k].classList.remove('is-active');
      });
      Object.keys(panels).forEach(function (k) {
        if (panels[k]) panels[k].classList.remove('is-open');
      });
    }

    // ── TEXT: tap on card → open text tool ──────────────────────────────────
    if (cardEl) {
      cardEl.addEventListener('click', function (e) {
        if (e.target.closest('.mdc__card-sticker-item')) return;
        if (e.target.closest('.mdc__panel')) return;
        openTool('text');
        // Focus must be called synchronously inside the event handler on mobile
        if (cardText) focusAtEnd(cardText);
      });
    }

    // ── TEXT: auto-fit font size ─────────────────────────────────────────────
    function fitCardText() {
      if (!cardText) return;
      const MAX_SIZE = 27;
      const MIN_SIZE = 9;
      cardText.style.fontSize = MAX_SIZE + 'px';
      while (
        cardText.scrollHeight > cardText.clientHeight &&
        parseFloat(cardText.style.fontSize) > MIN_SIZE
      ) {
        cardText.style.fontSize = (parseFloat(cardText.style.fontSize) - 0.5) + 'px';
      }
    }

    // ── TEXT: prevent iOS auto-zoom on focus (font-size < 16px triggers zoom)
    (function () {
      const viewportMeta = document.querySelector('meta[name="viewport"]');
      if (!viewportMeta || !cardText) return;
      cardText.addEventListener('focus', function () {
        const c = viewportMeta.content;
        viewportMeta._mdcOrig = c;
        viewportMeta.content = c.replace(/,?\s*user-scalable\s*=\s*[^,]*/gi, '') + ', user-scalable=no';
      });
      cardText.addEventListener('blur', function () {
        if (viewportMeta._mdcOrig) {
          viewportMeta.content = viewportMeta._mdcOrig;
          delete viewportMeta._mdcOrig;
        }
      });
    })();

    // ── TEXT: "Siguiente" button ─────────────────────────────────────────────
    if (cardText) {
      cardText.addEventListener('input', function () {
        fitCardText();
      });
    }

    if (textSiguiente) {
      textSiguiente.addEventListener('click', function () {
        openTool('sticker');
      });
    }

    // ── TOOLS ────────────────────────────────────────────────────────────────
    Object.keys(toolBtns).forEach(function (key) {
      if (!toolBtns[key]) return;
      if (key === 'voice') {
        toolBtns[key].addEventListener('click', function () {
          if (toolBtns[key].dataset.hasAudio === 'true' && audioBlob) {
            // Reabrir panel en estado recorded
            openTool('voice');
            setVoiceState('recorded');
          } else {
            openTool('voice');
            setVoiceState('idle');
          }
        });
      } else {
        toolBtns[key].addEventListener('click', function () {
          openTool(key);
          if (key === 'text' && cardText) focusAtEnd(cardText);
        });
      }
    });

    var toolsEl = mdcEl ? mdcEl.querySelector('.mdc__tools') : null;

    function openTool(tool) {
      Object.keys(toolBtns).forEach(function (k) {
        if (toolBtns[k]) toolBtns[k].classList.toggle('is-active', k === tool);
      });
      Object.keys(panels).forEach(function (k) {
        if (panels[k]) panels[k].classList.toggle('is-open', k === tool);
      });

      const isTextStep = (tool === 'text');
      if (!isDesktop()) {
        // Mobile only: show card, toggle SIGUIENTE, hide tool icons
        if (isTextStep && cardWrapEl) cardWrapEl.style.display = '';
        if (textSiguiente) textSiguiente.classList.toggle('is-visible', isTextStep);
        if (toolsEl) toolsEl.style.display = isTextStep ? 'none' : '';
      }
    }

    // ── FONT SELECTION ───────────────────────────────────────────────────────
    if (fontList) {
      fontList.querySelectorAll('.mdc__font-option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          fontList.querySelectorAll('.mdc__font-option').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          currentFont = btn.dataset.font;
          if (cardText) cardText.style.fontFamily = currentFont;
        });
      });
    }

    // ── SIZE SELECTION (mobile) ──────────────────────────────────────────────
    const sizeList = document.getElementById('mdc-size-list-' + id);
    if (sizeList) {
      if (cardText) cardText.style.fontSize = currentSize + 'px';
      sizeList.querySelectorAll('.mdc__size-option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          sizeList.querySelectorAll('.mdc__size-option').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          currentSize = parseInt(btn.dataset.size, 10);
          if (cardText) cardText.style.fontSize = currentSize + 'px';
        });
      });
    }

    // ── PANEL: swipe-to-close ────────────────────────────────────────────────
    Object.keys(panels).forEach(function (key) {
      const panel = panels[key];
      if (!panel) return;

      let swipeStartY = 0;
      let dragging    = false;
      const CLOSE_THRESHOLD = 40; // px

      if (!panel.querySelector('.mdc__panel-handle')) return;

      function swipeStart(e) {
        swipeStartY = (e.touches ? e.touches[0] : e).clientY;
        dragging    = true;
        panel.style.transition = 'none';
      }

      function swipeMove(e) {
        if (!dragging) return;
        let dy = (e.touches ? e.touches[0] : e).clientY - swipeStartY;
        if (dy < 0) dy = 0;
        panel.style.transform = 'translateY(' + dy + 'px)';
      }

      function closePanel() {
        const panelH = panel.offsetHeight;
        panel.style.transform = 'translateY(' + panelH + 'px)';
        panel.classList.remove('is-open');
        if (toolBtns[key]) toolBtns[key].classList.remove('is-active');
        panel.addEventListener('transitionend', function cleanup() {
          panel.removeEventListener('transitionend', cleanup);
          panel.style.transform = '';
          panel.style.transition = '';
        }, { once: true });
      }

      function swipeEnd(e) {
        if (!dragging) return;
        dragging = false;
        panel.style.transition = '';
        const dy = (e.changedTouches ? e.changedTouches[0] : e).clientY - swipeStartY;
        if (dy > CLOSE_THRESHOLD) {
          closePanel();
        } else {
          panel.style.transform = '';
        }
      }

      panel.addEventListener('touchstart', swipeStart, { passive: true });
      panel.addEventListener('touchmove',  swipeMove,  { passive: false });
      panel.addEventListener('touchend',   swipeEnd,   { passive: true });
    });

    // ── STICKERS ─────────────────────────────────────────────────────────────
    if (stickerGrid) {
      stickerGrid.querySelectorAll('.mdc__sticker-item').forEach(function (item) {
        item.addEventListener('click', function (e) {
          e.stopPropagation();
          addSticker(item);
          // Cerrar panel en mobile al seleccionar sticker
          if (!isDesktop()) {
            if (panels.sticker) panels.sticker.classList.remove('is-open');
            if (toolBtns.sticker) toolBtns.sticker.classList.remove('is-active');
          }
        });
      });
    }

    function addSticker(item) {
      if (!stickerLayer) return;

      const el = document.createElement('div');
      el.className = 'mdc__card-sticker-item';

      // Place sticker at center of card, relative to the editor-level stickerLayer
      const layerRect = stickerLayer.getBoundingClientRect();
      const cardRef   = cardEl || document.querySelector('.mdc__card');
      const cardRect  = cardRef ? cardRef.getBoundingClientRect() : null;
      const initLeft  = cardRect ? Math.round(cardRect.left - layerRect.left + cardRect.width  / 2 - 24) : 20;
      const initTop   = cardRect ? Math.round(cardRect.top  - layerRect.top  + cardRect.height / 2 - 24) : 20;
      el.style.left = initLeft + 'px';
      el.style.top  = initTop  + 'px';

      if (item.dataset.stickerEmoji) {
        const span = document.createElement('span');
        span.textContent = item.dataset.stickerEmoji;
        span.style.fontSize = '5rem';
        el.appendChild(span);
      } else if (item.dataset.stickerSrc) {
        const img = document.createElement('img');
        img.crossOrigin = 'anonymous';
        img.src = item.dataset.stickerSrc;
        el.appendChild(img);
      }

      // Botón X para eliminar el sticker
      const removeBtn = document.createElement('button');
      removeBtn.className = 'mdc__sticker-remove';
      removeBtn.innerHTML = '<svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
      removeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        el.remove();
      });
      removeBtn.addEventListener('mousedown', function (e) { e.stopPropagation(); });
      removeBtn.addEventListener('touchstart', function (e) { e.stopPropagation(); }, { passive: true });
      el.appendChild(removeBtn);

      makeDraggable(el);
      stickerLayer.appendChild(el);
    }

    function makeDraggable(el) {
      let startX, startY, startLeft, startTop;
      let overTrash = false;
      const TRASH_THRESHOLD = 100; // px desde el borde inferior del editor

      function onStart(e) {
        e.preventDefault();
        const touch = e.touches ? e.touches[0] : e;
        startX    = touch.clientX;
        startY    = touch.clientY;
        startLeft = parseInt(el.style.left) || 0;
        startTop  = parseInt(el.style.top)  || 0;
        overTrash = false;
        if (!isDesktop() && stickerTrash) stickerTrash.classList.add('is-active');
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onEnd);
        document.addEventListener('touchmove', onMove, { passive: false });
        document.addEventListener('touchend', onEnd);
      }

      function onMove(e) {
        e.preventDefault();
        const touch = e.touches ? e.touches[0] : e;
        const dx = touch.clientX - startX;
        const dy = touch.clientY - startY;
        el.style.left = (startLeft + dx) + 'px';
        el.style.top  = (startTop  + dy) + 'px';

        // Detectar proximidad a papelera (solo mobile)
        if (!isDesktop() && stickerLayer) {
          const layerRect = stickerLayer.getBoundingClientRect();
          const elRect    = el.getBoundingClientRect();
          const elCenterY = elRect.top + elRect.height / 2;
          const distFromBottom = layerRect.bottom - elCenterY;

          if (distFromBottom < TRASH_THRESHOLD) {
            overTrash = true;
            if (stickerTrash) stickerTrash.classList.add('is-hover');
            const scale = Math.max(0.25, distFromBottom / TRASH_THRESHOLD);
            el.style.transform = 'scale(' + scale + ')';
          } else {
            overTrash = false;
            if (stickerTrash) stickerTrash.classList.remove('is-hover');
            el.style.transform = '';
          }
        }
      }

      function onEnd() {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onEnd);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('touchend', onEnd);
        if (!isDesktop() && stickerTrash) {
          stickerTrash.classList.remove('is-active');
          stickerTrash.classList.remove('is-hover');
        }
        if (overTrash) {
          el.remove();
        } else {
          el.style.transform = '';
        }
      }

      el.addEventListener('mousedown', onStart);
      el.addEventListener('touchstart', onStart, { passive: false });
    }

    // ── VOICE: estado de la UI ───────────────────────────────────────────────
    function setVoiceState(state) {
      if (voicePanelEl) voicePanelEl.dataset.state = state;
    }

    // ── VOICE: grabación con press-and-hold ──────────────────────────────────
    if (recordBtn) {
      recordBtn.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        recordBtn.setPointerCapture(e.pointerId);
        setVoiceState('recording');
        startRecording();
      });

      recordBtn.addEventListener('pointerup', function () {
        stopRecording();
      });

      recordBtn.addEventListener('pointercancel', function () {
        stopRecording();
      });
    }

    function startRecording() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) return;
      navigator.mediaDevices.getUserMedia({ audio: true }).then(function (stream) {
        audioChunks = [];
        mediaRecorder = new MediaRecorder(stream);
        mediaRecorder.ondataavailable = function (e) { audioChunks.push(e.data); };
        mediaRecorder.onstop = function () {
          audioBlob = new Blob(audioChunks, { type: 'audio/webm' });
          // Invalidar player anterior si existe
          if (audioPlayer) { audioPlayer.pause(); audioPlayer = null; }
          stream.getTracks().forEach(function (t) { t.stop(); });
          // Copiar tiempo final al display de estado recorded
          const finalTime = timerEl ? timerEl.textContent : '0:00';
          if (timerDisplayEl) timerDisplayEl.textContent = finalTime;
          clearInterval(waveInterval);
          resetWaveform();
          setVoiceState('recorded');
        };
        mediaRecorder.start();
        if (recordBtn) recordBtn.classList.add('is-recording');
        recordSeconds = 0;
        clearInterval(recordTimer);
        recordTimer = setInterval(function () {
          recordSeconds++;
          const m = Math.floor(recordSeconds / 60);
          const s = recordSeconds % 60;
          const t = m + ':' + (s < 10 ? '0' : '') + s;
          if (timerEl) timerEl.textContent = t;
          if (timerDisplayEl) timerDisplayEl.textContent = t;
        }, 1000);
        clearInterval(waveInterval);
        waveInterval = setInterval(animateWaveform, 100);
      }).catch(function () {
        setVoiceState('idle');
      });
    }

    function stopRecording() {
      if (mediaRecorder && mediaRecorder.state === 'recording') {
        mediaRecorder.stop();
      }
      clearInterval(recordTimer);
      if (recordBtn) recordBtn.classList.remove('is-recording');
      // onstop callback se encarga del resto
    }

    function animateWaveform() {
      if (!waveform) return;
      waveform.querySelectorAll('.mdc__waveform-bar').forEach(function (bar) {
        bar.style.height = (Math.random() * 24 + 8) + 'px';
      });
    }

    function resetWaveform() {
      if (!waveform) return;
      const heights = [27,11,17,11,11,17,17,11,11,27,11,17,11,11,17,11,27,17,17,11,11,27,11,17,11,11,17,11];
      waveform.querySelectorAll('.mdc__waveform-bar').forEach(function (bar, i) {
        bar.style.height = (heights[i] || 14) + 'px';
      });
    }

    // ── VOICE: controles post-grabación ─────────────────────────────────────
    if (voiceDeleteBtn) {
      voiceDeleteBtn.addEventListener('click', function () {
        audioBlob = null;
        if (audioPlayer) { audioPlayer.pause(); audioPlayer = null; }
        // Reset timers
        if (timerEl) timerEl.textContent = '0:00';
        if (timerDisplayEl) timerDisplayEl.textContent = '0:00';
        recordSeconds = 0;
        setVoiceState('idle');
        // Cerrar panel
        openTool(null);
        if (toolBtns.voice) toolBtns.voice.classList.remove('is-active');
        updateVoiceToolIcon(false);
      });
    }

    if (voicePlayBtn) {
      voicePlayBtn.addEventListener('click', function () {
        if (!audioBlob) return;
        if (audioPlayer && !audioPlayer.paused) {
          audioPlayer.pause();
          setPlayBtnState(false);
        } else {
          if (!audioPlayer) {
            audioPlayer = new Audio(URL.createObjectURL(audioBlob));
            audioPlayer.onended = function () { setPlayBtnState(false); };
          }
          audioPlayer.play();
          setPlayBtnState(true);
        }
      });
    }

    function setPlayBtnState(playing) {
      if (!voicePlayBtn) return;
      const playIcon  = voicePlayBtn.querySelector('.mdc__play-icon');
      const pauseIcon = voicePlayBtn.querySelector('.mdc__pause-icon');
      if (playIcon)  playIcon.style.display  = playing ? 'none'  : '';
      if (pauseIcon) pauseIcon.style.display = playing ? ''      : 'none';
    }

    if (voiceConfirmBtn) {
      voiceConfirmBtn.addEventListener('click', function () {
        if (audioPlayer) { audioPlayer.pause(); audioPlayer = null; }
        // Cerrar panel
        openTool(null);
        if (toolBtns.voice) toolBtns.voice.classList.remove('is-active');
        updateVoiceToolIcon(true);
      });
    }

    function updateVoiceToolIcon(hasAudio) {
      if (!toolBtns.voice) return;
      if (hasAudio) {
        toolBtns.voice.innerHTML = '<svg viewBox="0 0 24 24"><polygon points="5 3 19 12 5 21 5 3" fill="currentColor" stroke="none"/></svg>';
        toolBtns.voice.dataset.hasAudio = 'true';
      } else {
        toolBtns.voice.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2a3 3 0 0 1 3 3v7a3 3 0 0 1-6 0V5a3 3 0 0 1 3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>';
        delete toolBtns.voice.dataset.hasAudio;
      }
    }

    // ── COMPARTIR: state machine ─────────────────────────────────────────────
    const shareMuroBtn      = document.getElementById('mdc-share-muro-' + id);
    const shareMadreBtn     = document.getElementById('mdc-share-madre-' + id);
    const shareMuroOnlyEl   = document.getElementById('mdc-share-muro-only-' + id);
    const shareMuroOnlyBtn  = document.getElementById('mdc-share-muro-only-btn-' + id);
    const muroViewEl        = document.getElementById('mdc-muro-view-' + id);
    const muroCloseBtn      = document.getElementById('mdc-muro-close-' + id);
    const muroCardsEl       = document.getElementById('mdc-muro-cards-' + id);
    const muroThankyouEl    = document.getElementById('mdc-muro-thankyou-' + id);
    const muroShareMadreBtn = document.getElementById('mdc-muro-share-madre-' + id);
    var inspireViewEl     = document.getElementById('mdc-inspire-view-' + id);

    // Abre la choice sheet
    if (compartir) {
      compartir.addEventListener('click', function () {
        if (shareOverlay) shareOverlay.classList.add('is-open');
      });
    }

    // Cerrar choice sheet al pulsar el backdrop
    if (shareOverlay) {
      shareOverlay.addEventListener('click', function (e) {
        if (e.target === shareOverlay) shareOverlay.classList.remove('is-open');
      });
    }

    // Flujo A: compartir en el muro primero
    if (shareMuroBtn) {
      shareMuroBtn.addEventListener('click', function () {
        shareOverlay.classList.remove('is-open');
        renderMuroView();
        openMuroView(true); // con thankyou sheet
      });
    }

    // Flujo B: compartir con tu madre primero
    if (shareMadreBtn) {
      shareMadreBtn.addEventListener('click', function () {
        shareOverlay.classList.remove('is-open');
        nativeShare(function () {
          showMuroOnlySheet();
        });
      });
    }

    // Muro-only sheet: compartir en el muro
    if (shareMuroOnlyBtn) {
      shareMuroOnlyBtn.addEventListener('click', function () {
        if (shareMuroOnlyEl) shareMuroOnlyEl.classList.remove('is-open');
        renderMuroView();
        openMuroView(false); // sin thankyou sheet
      });
    }

    // Cerrar muro-only sheet al pulsar el backdrop
    if (shareMuroOnlyEl) {
      shareMuroOnlyEl.addEventListener('click', function (e) {
        if (e.target === shareMuroOnlyEl) shareMuroOnlyEl.classList.remove('is-open');
      });
    }

    // Muro: botón X → cerrar muro y cerrar MDC (volver a inicio)
    if (muroCloseBtn) {
      muroCloseBtn.addEventListener('click', function () {
        closeMuroView();
        closeMdc();
      });
    }

    // Muro thankyou: cerrar sheet tirando del handle
    if (muroThankyouEl) {
      const thankyouHandle = muroThankyouEl.querySelector('.mdc__panel-handle');
      if (thankyouHandle) {
        thankyouHandle.addEventListener('click', function () {
          muroThankyouEl.classList.remove('is-open');
        });
      }
    }

    // Muro thankyou: compartir con tu madre → volver al editor y abrir share nativo
    if (muroShareMadreBtn) {
      muroShareMadreBtn.addEventListener('click', function () {
        closeMuroView();
        setTimeout(function () {
          nativeShare(null);
        }, 150);
      });
    }

    function openMuroView(showThankyou) {
      if (muroViewEl) muroViewEl.classList.add('is-open');
      if (muroThankyouEl) muroThankyouEl.classList.toggle('is-open', !!showThankyou);
    }

    function closeMuroView() {
      if (muroViewEl) muroViewEl.classList.remove('is-open');
      if (muroThankyouEl) muroThankyouEl.classList.remove('is-open');
    }

    function showMuroOnlySheet() {
      if (shareMuroOnlyEl) shareMuroOnlyEl.classList.add('is-open');
    }

    function renderMuroView() {
      if (!muroCardsEl || !muroViewEl) return;
      muroCardsEl.innerHTML = '';

      // Copiar el fondo del editor al muro
      const muroBgEl = document.getElementById('mdc-muro-bg-' + id);
      if (muroBgEl) {
        const srcBg = document.getElementById('mdc-editor-bg-' + id);
        if (srcBg) muroBgEl.innerHTML = srcBg.innerHTML;
      }

      // Crear tile con el contenido de la tarjeta
      const tile = document.createElement('div');
      tile.className = 'mdc__muro-user-card';

      const tileText = document.createElement('div');
      tileText.className = 'mdc__card-text';
      if (cardText) {
        tileText.innerHTML = cardText.innerHTML;
        tileText.style.fontFamily = cardText.style.fontFamily || currentFont;
        tileText.style.textAlign  = cardText.style.textAlign  || 'center';
        tileText.style.fontSize   = cardText.style.fontSize   || '';
      }
      tile.appendChild(tileText);

      // Copiar stickers (sin interacción)
      if (stickerLayer) {
        const stickerClone = stickerLayer.cloneNode(true);
        stickerClone.querySelectorAll('.mdc__card-sticker-item').forEach(function (el) {
          el.style.pointerEvents = 'none';
          el.style.cursor = 'default';
        });
        tile.appendChild(stickerClone);
      }

      muroCardsEl.appendChild(tile);
    }

    function nativeShare(onAfter) {
      const text = cardText ? cardText.innerText : '';
      let shareData = {
        title: 'SAY IT, Your Way - Brownie',
        text:  text,
        url:   window.location.href
      };

      // Intentar adjuntar el audio si está disponible
      if (audioBlob && navigator.canShare) {
        const audioFile = new File([audioBlob], 'mensaje-para-mama.webm', { type: 'audio/webm' });
        const withFile = Object.assign({}, shareData, { files: [audioFile] });
        if (navigator.canShare(withFile)) shareData = withFile;
      }

      if (navigator.share) {
        navigator.share(shareData)
          .then(function () { if (onAfter) onAfter(); })
          .catch(function () { if (onAfter) onAfter(); });
      } else {
        if (navigator.clipboard) navigator.clipboard.writeText(shareData.url).catch(function () {});
        if (onAfter) onAfter();
      }
    }

    // ── DESKTOP STEP MANAGEMENT ──────────────────────────────────────────────
    const DT_STEPS  = ['fondo', 'texto', 'sticker', 'audio', 'share'];
    let currentDtStep   = 'fondo';
    let dtWaveInterval  = null;
    let dtTimerInterval = null;
    let dtRecordSecs    = 0;
    let dtMediaRecorder = null;
    let dtAudioChunks   = [];

    const dtNextBtn       = document.getElementById('mdc-dt-next-' + id);
    const dtCloseBtn      = document.getElementById('mdc-dt-close-' + id);
    const dtTabsEl        = document.getElementById('mdc-dt-tabs-' + id);
    const dtThumbsEl      = document.getElementById('mdc-dt-thumbs-' + id);
    const dtFontDdEl      = document.getElementById('mdc-dt-font-dd-' + id);
    const dtSizeDdEl      = document.getElementById('mdc-dt-size-dd-' + id);
    const dtAlignsEl      = document.getElementById('mdc-dt-aligns-' + id);
    const dtStickerRow    = document.getElementById('mdc-dt-sticker-row-' + id);
    const dtStickerClose  = document.getElementById('mdc-dt-sticker-close-' + id);
    const dtAudioClose    = document.getElementById('mdc-dt-audio-close-' + id);
    const dtRecordBtn     = document.getElementById('mdc-dt-record-' + id);
    const dtWaveformEl    = document.getElementById('mdc-dt-waveform-' + id);
    const dtTimerEl       = document.getElementById('mdc-dt-timer-' + id);
    const dtShareX        = document.getElementById('mdc-dt-share-x-' + id);
    const dtShareMuroBtn  = document.getElementById('mdc-dt-share-muro-' + id);
    const dtShareMadreBtn = document.getElementById('mdc-dt-share-madre-' + id);
    const dtCompartirBtn  = document.getElementById('mdc-dt-compartir-' + id);

    const DT_BTN_LABELS = {
      fondo:   'Siguiente',
      texto:   'Siguiente',
      sticker: 'Deshacer',
      audio:   'Siguiente',
      share:   'Finalizar'
    };

    function isDesktop() { return window.innerWidth >= 1024; }

    const dtTopEl     = mdcEl ? mdcEl.querySelector('.mdc__dt-top') : null;
    const dtFondoUiEl = document.getElementById('mdc-dt-fondo-ui-' + id);

    function goToDtStep(step) {
      currentDtStep = step;
      if (mdcEl) mdcEl.setAttribute('data-dt-step', step);

      if (dtTabsEl) {
        dtTabsEl.querySelectorAll('.mdc__dt-tab').forEach(function (tab) {
          tab.classList.toggle('is-active', tab.dataset.dtTab === step);
        });
      }

      if (dtNextBtn) dtNextBtn.textContent = DT_BTN_LABELS[step] || 'Siguiente';

      const cardWrap = document.querySelector('.mdc__card-wrap');
      if (cardWrap) {
        cardWrap.style.opacity       = (step === 'fondo') ? '0' : '';
        cardWrap.style.pointerEvents = (step === 'fondo') ? 'none' : '';
      }

      if (step !== 'audio') {
        clearInterval(dtWaveInterval);
        clearInterval(dtTimerInterval);
      }

      if (step === 'texto' && cardText) {
        setTimeout(function () { focusAtEnd(cardText); }, 50);
      }
    }

    function advanceDtStep() {
      if (currentDtStep === 'sticker') { undoLastDtSticker(); return; }
      if (currentDtStep === 'share')   { closeMdc(); return; }
      const idx = DT_STEPS.indexOf(currentDtStep);
      if (idx < DT_STEPS.length - 1) goToDtStep(DT_STEPS[idx + 1]);
    }

    function undoLastDtSticker() {
      if (!stickerLayer) return;
      const items = stickerLayer.querySelectorAll('.mdc__card-sticker-item');
      if (items.length > 0) items[items.length - 1].remove();
    }

    function setDtBackground(idx) {
      if (!fondosEl) return;
      const _fondoEls = fondosEl.querySelectorAll('.mdc__fondo');
      const selected = _fondoEls[idx - 1];
      if (!selected) return;

      const w          = window.innerWidth;
      const tabletSrc  = selected.dataset.tabletSrc;
      const desktopSrc = selected.dataset.desktopSrc;
      const mobileImg  = selected.querySelector('img');
      const mobileSrc  = mobileImg ? mobileImg.src : null;
      const bestSrc    = (w >= 1280 && desktopSrc) ? desktopSrc
        : (w >= 768  && tabletSrc)  ? tabletSrc
          : mobileSrc;

      // Remove only bg images, keeping editorBgCss in the DOM
      editorBg.querySelectorAll('img').forEach(function (i) { i.remove(); });

      if (bestSrc) {
        if (editorBgCss) {
          editorBgCss.style.background = '';
          editorBgCss.className = 'mdc__editor-bg--css';
        }
        const newImg = document.createElement('img');
        newImg.crossOrigin = 'anonymous';
        newImg.src = bestSrc;
        newImg.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;';
        editorBg.appendChild(newImg);
      } else if (editorBgCss) {
        const classes = Array.prototype.slice.call(selected.classList);
        const bgClass = classes.find(function (c) { return /^mdc__fondo--\d+$/.test(c); });
        editorBgCss.className = 'mdc__editor-bg--css ' + (bgClass || '');
      }
    }

    function openMdcDesktop() {
      if (editor) editor.classList.add('is-active');
      if (fondoUi) fondoUi.style.display = 'none';
      setDtBackground(currentFondo);
      goToDtStep('fondo');
    }

    document.addEventListener('mothers-day:open', function () {
      if (isDesktop()) openMdcDesktop();
    });

    // ── click en el fondo → paso fondo (desktop) / abrir texto (mobile) ──
    if (editorBg) {
      editorBg.addEventListener('click', function () {
        if (isDesktop()) {
          // Desktop: clicking background does nothing (navigation is via tabs/buttons only)
          return;
        } else {
          // Tap on background (mobile) → enter text step
          if (cardWrapEl && cardWrapEl.style.display === 'none') {
            openTool('text');
            if (cardText) focusAtEnd(cardText);
          }
        }
      });
    }

    if (dtThumbsEl) {
      dtThumbsEl.querySelectorAll('.mdc__dt-thumb').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          dtThumbsEl.querySelectorAll('.mdc__dt-thumb').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          const _thumbs = Array.prototype.slice.call(dtThumbsEl.querySelectorAll('.mdc__dt-thumb'));
          currentFondo = _thumbs.indexOf(thumb) + 1;
          setDtBackground(currentFondo);
        });
      });
    }

    if (dtTabsEl) {
      dtTabsEl.querySelectorAll('.mdc__dt-tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
          if (tab.dataset.dtTab) goToDtStep(tab.dataset.dtTab);
        });
      });
    }

    if (dtNextBtn)      dtNextBtn.addEventListener('click', advanceDtStep);
    if (dtCloseBtn)     dtCloseBtn.addEventListener('click', closeMdc);
    if (dtStickerClose) dtStickerClose.addEventListener('click', function () { goToDtStep('texto'); });

    if (dtStickerRow) {
      dtStickerRow.querySelectorAll('.mdc__dt-sticker-item').forEach(function (item) {
        item.addEventListener('click', function () { addSticker(item); });
      });
    }

    // ── DESKTOP DROPDOWNS (font + size) ─────────────────────────────────────
    function initDtDropdown(ddEl, onSelect) {
      if (!ddEl) return;
      const btn  = ddEl.querySelector('.mdc__dt-dd-btn');
      const list = ddEl.querySelector('.mdc__dt-dd-list');
      const label = ddEl.querySelector('.mdc__dt-dd-label');

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        const isOpen = ddEl.classList.toggle('is-open');
        // Close other dropdowns
        [dtFontDdEl, dtSizeDdEl].forEach(function (el) {
          if (el && el !== ddEl) el.classList.remove('is-open');
        });
      });

      list.querySelectorAll('.mdc__dt-dd-opt').forEach(function (opt) {
        opt.addEventListener('click', function (e) {
          e.stopPropagation();
          list.querySelectorAll('.mdc__dt-dd-opt').forEach(function (o) { o.classList.remove('is-active'); });
          opt.classList.add('is-active');
          label.textContent = opt.dataset.label;
          ddEl.classList.remove('is-open');
          onSelect(opt);
        });
      });
    }

    initDtDropdown(dtFontDdEl, function (opt) {
      currentFont = opt.dataset.font;
      if (cardText) cardText.style.fontFamily = currentFont;
    });

    initDtDropdown(dtSizeDdEl, function (opt) {
      currentSize = parseInt(opt.dataset.size, 10);
      if (cardText) cardText.style.fontSize = currentSize + 'px';
    });
    if (cardText) cardText.style.fontSize = currentSize + 'px';

    // Close dropdowns on outside click
    document.addEventListener('click', function () {
      if (dtFontDdEl) dtFontDdEl.classList.remove('is-open');
      if (dtSizeDdEl) dtSizeDdEl.classList.remove('is-open');
    });

    if (dtAlignsEl) {
      dtAlignsEl.querySelectorAll('.mdc__dt-align-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          dtAlignsEl.querySelectorAll('.mdc__dt-align-btn').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (cardText) cardText.style.textAlign = btn.dataset.align;
        });
      });
    }

    if (dtAudioClose) dtAudioClose.addEventListener('click', function () { goToDtStep('texto'); });

    if (dtRecordBtn) {
      dtRecordBtn.addEventListener('click', function () {
        if (dtMediaRecorder && dtMediaRecorder.state === 'recording') {
          dtStopRecording();
        } else {
          dtStartRecording();
        }
      });
    }

    function dtStartRecording() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) return;
      navigator.mediaDevices.getUserMedia({ audio: true }).then(function (stream) {
        dtAudioChunks = [];
        dtMediaRecorder = new MediaRecorder(stream);
        dtMediaRecorder.ondataavailable = function (e) { dtAudioChunks.push(e.data); };
        dtMediaRecorder.onstop = function () {
          audioBlob = new Blob(dtAudioChunks, { type: 'audio/webm' });
          stream.getTracks().forEach(function (t) { t.stop(); });
        };
        dtMediaRecorder.start();
        if (dtRecordBtn) dtRecordBtn.classList.add('is-recording');
        dtRecordSecs = 0;
        clearInterval(dtTimerInterval);
        dtTimerInterval = setInterval(function () {
          dtRecordSecs++;
          const m = Math.floor(dtRecordSecs / 60);
          const s = dtRecordSecs % 60;
          if (dtTimerEl) dtTimerEl.textContent = m + ':' + (s < 10 ? '0' : '') + s;
        }, 1000);
        clearInterval(dtWaveInterval);
        dtWaveInterval = setInterval(function () {
          if (!dtWaveformEl) return;
          dtWaveformEl.querySelectorAll('.mdc__waveform-bar').forEach(function (bar) {
            bar.style.height = (Math.random() * 24 + 8) + 'px';
          });
        }, 100);
      }).catch(function () {});
    }

    function dtStopRecording() {
      if (dtMediaRecorder && dtMediaRecorder.state === 'recording') dtMediaRecorder.stop();
      clearInterval(dtTimerInterval);
      clearInterval(dtWaveInterval);
      if (dtRecordBtn) dtRecordBtn.classList.remove('is-recording');
    }

    if (dtCompartirBtn) dtCompartirBtn.addEventListener('click', function () { goToDtStep('share'); });

    if (dtShareX) dtShareX.addEventListener('click', function () { goToDtStep('texto'); });

    // Desktop: compartir en el muro
    if (dtShareMuroBtn) {
      dtShareMuroBtn.addEventListener('click', function () {
        goToDtStep('texto');
        renderMuroView();
        openMuroView(true);
      });
    }

    // Desktop: compartir con tu madre
    if (dtShareMadreBtn) {
      dtShareMadreBtn.addEventListener('click', function () {
        goToDtStep('texto');
        nativeShare(function () {
          showMuroOnlySheet();
        });
      });
    }

    // ── INSPIRE VIEW ─────────────────────────────────────────────────────────
    const inspireCloseBtn  = document.getElementById('mdc-inspire-close-' + id);
    const inspireCardsEl   = document.getElementById('mdc-inspire-cards-' + id);
    const inspireHintEl    = document.getElementById('mdc-inspire-hint-' + id);
    const inspireCtaBtn    = document.getElementById('mdc-inspire-cta-' + id);
    let inspireHintTimer = null;
    let inspireFeaturedIdx = 0;
    let inspireTiles = [];

    // Scatter positions: [left%, top%, rotate(deg), zIndex] — index 0 = featured center
    const INSPIRE_POSITIONS = [
      { left: '50%',  top: '48%', rot:  0,   z: 10, scale: 1.0   }, // featured
      { left: '22%',  top: '17%', rot: -3,   z: 5,  scale: 0.62  }, // top-left
      { left: '58%',  top:  '6%', rot:  1,   z: 4,  scale: 0.50  }, // top-center
      { left: '90%',  top: '14%', rot:  4,   z: 3,  scale: 0.55  }, // top-right (partial)
      { left: '90%',  top: '54%', rot:  3,   z: 5,  scale: 0.60  }, // right-center
      { left: '10%',  top: '72%', rot: -4,   z: 4,  scale: 0.60  }, // bottom-left
      { left: '86%',  top: '78%', rot:  5,   z: 3,  scale: 0.55  }  // bottom-right (partial)
    ];

    document.addEventListener('mothers-day:inspire', openInspireView);
    document.addEventListener('mothers-day:open-creator', function () {
      closeInspireView();
      if (isDesktop()) {
        openMdcDesktop();
      } else {
        openMdc();
      }
    });

    function openInspireView() {
      openMdc();
      if (inspireViewEl) inspireViewEl.classList.add('is-open');
      loadInspireCards();
      showInspireHint();
    }

    function closeInspireView() {
      if (inspireViewEl) inspireViewEl.classList.remove('is-open');
      clearTimeout(inspireHintTimer);
    }

    function showInspireHint() {
      if (!inspireHintEl) return;
      inspireHintEl.classList.add('is-visible');
      clearTimeout(inspireHintTimer);
      inspireHintTimer = setTimeout(function () {
        inspireHintEl.classList.remove('is-visible');
      }, 3000);
    }

    function loadInspireCards() {
      if (!inspireCardsEl) return;
      inspireCardsEl.innerHTML = '';
      inspireTiles = [];
      inspireFeaturedIdx = 0;
      if (saveEndpoint) {
        fetch(saveEndpoint + '/get-cards?limit=50')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            const cards = Array.isArray(data) ? data : (data.cards || []);
            renderInspireCards(cards.slice(0, 50));
          })
          .catch(function () { renderInspireCards([]); });
      } else {
        renderInspireCards([]);
      }
    }

    function renderInspireCards(cards) {
      if (!inspireCardsEl) return;
      inspireCardsEl.innerHTML = '';
      inspireTiles = [];
      cards.forEach(function (card, i) {
        const tile = document.createElement('div');
        tile.className = 'mdc__inspire-card';
        if (card.background_url) {
          tile.style.backgroundImage = 'url(' + card.background_url + ')';
        } else if (card.background_class) {
          tile.classList.add(card.background_class);
        }
        const textEl = document.createElement('div');
        textEl.className = 'mdc__card-text';
        textEl.textContent = card.text || '';
        if (card.font) textEl.style.fontFamily = card.font;
        if (card.align) textEl.style.textAlign = card.align;
        tile.appendChild(textEl);
        tile.addEventListener('click', function () {
          if (!tile.classList.contains('is-featured')) {
            const tileIdx = inspireTiles.indexOf(tile);
            if (tileIdx !== -1) inspireSetFeatured(tileIdx);
          }
        });
        inspireCardsEl.appendChild(tile);
        inspireTiles.push(tile);
      });
      inspireApplyPositions();
      inspireBindSwipe();
    }

    function inspireApplyPositions() {
      const n = inspireTiles.length;
      if (n === 0) return;
      const pos = INSPIRE_POSITIONS;
      inspireTiles.forEach(function (tile, i) {
        // Compute position slot relative to featured
        const slot = ((i - inspireFeaturedIdx) % n + n) % n;
        const p = pos[slot] || pos[(slot % pos.length)];
        tile.style.left = p.left;
        tile.style.top  = p.top;
        tile.style.transform = 'translate(-50%, -50%) rotate(' + p.rot + 'deg) scale(' + p.scale + ')';
        tile.style.zIndex = p.z;
        tile.classList.toggle('is-featured', slot === 0);
      });
    }

    function inspireSetFeatured(idx) {
      inspireFeaturedIdx = idx;
      inspireApplyPositions();
    }

    function inspireBindSwipe() {
      if (!inspireViewEl) return;
      let sx = 0;
      inspireViewEl.addEventListener('touchstart', function (e) {
        sx = e.touches[0].clientX;
      }, { passive: true });
      inspireViewEl.addEventListener('touchend', function (e) {
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) < 40) return;
        const n = inspireTiles.length;
        if (n === 0) return;
        inspireFeaturedIdx = dx < 0
          ? (inspireFeaturedIdx + 1) % n
          : (inspireFeaturedIdx - 1 + n) % n;
        inspireApplyPositions();
      }, { passive: true });
    }

    if (inspireCloseBtn) {
      inspireCloseBtn.addEventListener('click', function () {
        closeInspireView();
        closeMdc();
      });
    }

    if (inspireCtaBtn) {
      inspireCtaBtn.addEventListener('click', function () {
        closeInspireView();
        if (isDesktop()) {
          openMdcDesktop();
        } else {
          openMdc();
        }
      });
    }

    // ── DOWNLOAD ─────────────────────────────────────────────────────────────
    const downloadBtn   = document.getElementById('mdc-download-'    + id);
    const dtDownloadBtn = document.getElementById('mdc-dt-download-' + id);

    function loadCORSImage(src) {
      return new Promise(function (resolve, reject) {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload  = function () { resolve(img); };
        img.onerror = reject;
        img.src = src.indexOf('?') >= 0 ? src + '&_cors=1' : src + '?_cors=1';
      });
    }

    function breakWord(ctx, word, maxWidth) {
      const parts = [];
      let chunk = '';
      for (let c = 0; c < word.length; c++) {
        const test = chunk + word[c];
        if (ctx.measureText(test).width <= maxWidth) {
          chunk = test;
        } else {
          if (chunk) parts.push(chunk);
          chunk = word[c];
        }
      }
      if (chunk) parts.push(chunk);
      return parts;
    }

    function wrapTextCanvas(ctx, text, maxWidth) {
      const lines      = [];
      const paragraphs = text.split('\n');
      for (let p = 0; p < paragraphs.length; p++) {
        const para = paragraphs[p];
        if (!para) { lines.push(''); continue; }
        const words = para.split(' ');
        let line  = '';
        for (let w = 0; w < words.length; w++) {
          const word = words[w];
          if (ctx.measureText(word).width > maxWidth) {
            if (line) { lines.push(line); line = ''; }
            const parts = breakWord(ctx, word, maxWidth);
            for (let i = 0; i < parts.length - 1; i++) lines.push(parts[i]);
            line = parts[parts.length - 1] || '';
            continue;
          }
          const test = line ? line + ' ' + word : word;
          if (ctx.measureText(test).width <= maxWidth) {
            line = test;
          } else {
            if (line) lines.push(line);
            line = word;
          }
        }
        if (line) lines.push(line);
      }
      return lines;
    }

    function generateCardCanvas() {
      return document.fonts.ready.then(function () {
        const scale      = 2;
        const editorRect = editor.getBoundingClientRect();
        const W = editorRect.width  * scale;
        const H = editorRect.height * scale;

        const canvas    = document.createElement('canvas');
        canvas.width  = W;
        canvas.height = H;
        const ctx = canvas.getContext('2d');

        // 1. Background
        const bgImgEl = editorBg.querySelector('img');

        function drawBackground() {
          // Try drawing already-loaded DOM img directly first (avoids CORS double-fetch issue)
          if (bgImgEl && bgImgEl.complete && bgImgEl.naturalWidth > 0) {
            try {
              ctx.drawImage(bgImgEl, 0, 0, W, H);
              return Promise.resolve();
            } catch (secErr) {
              // Cross-origin taint – fall through to loadCORSImage
            }
          }
          if (bgImgEl && bgImgEl.src) {
            return loadCORSImage(bgImgEl.src).then(function (img) {
              ctx.drawImage(img, 0, 0, W, H);
            }).catch(function () {
              ctx.fillStyle = '#0d1b35';
              ctx.fillRect(0, 0, W, H);
            });
          }
          // CSS background fallback (color o gradiente)
          const editorBgCssEl = editorBg.querySelector('.mdc__editor-bg--css') || editorBgCss;
          const computed = editorBgCssEl ? window.getComputedStyle(editorBgCssEl) : null;
          const bgImage  = computed ? computed.backgroundImage  : '';
          const bgColor  = computed ? computed.backgroundColor  : '';
          if (bgImage && bgImage !== 'none') {
            const urlMatch = bgImage.match(/url\(["']?([^"')]+)["']?\)/);
            if (urlMatch) {
              return loadCORSImage(urlMatch[1]).then(function (img) {
                ctx.drawImage(img, 0, 0, W, H);
              }).catch(function () {
                ctx.fillStyle = (bgColor && bgColor !== 'rgba(0, 0, 0, 0)') ? bgColor : '#0d1b35';
                ctx.fillRect(0, 0, W, H);
              });
            }
          }
          ctx.fillStyle = (bgColor && bgColor !== 'rgba(0, 0, 0, 0)') ? bgColor : '#0d1b35';
          ctx.fillRect(0, 0, W, H);
          return Promise.resolve();
        }

        return drawBackground().then(function () {
          // 2. Overlay oscuro (14%)
          ctx.fillStyle = 'rgba(0,0,0,0.14)';
          ctx.fillRect(0, 0, W, H);

          // 3. Posición de la card relativa al editor
          const cardWrapEl = document.querySelector('.mdc__card-wrap');
          const cardRect   = cardWrapEl.getBoundingClientRect();
          const cx = (cardRect.left  - editorRect.left) * scale;
          const cy = (cardRect.top   - editorRect.top)  * scale;
          const cw =  cardRect.width  * scale;
          const ch =  cardRect.height * scale;

          // 4. Fondo blanco de la card
          ctx.fillStyle = '#fffcf5';
          ctx.fillRect(cx, cy, cw, ch);

          // 5. Texto
          const rawText   = cardText ? (cardText.innerText || '').trim() : '';
          const fontSize  = parseFloat(cardText && cardText.style.fontSize) || 27;
          const fontFam   = (cardText && cardText.style.fontFamily) || currentFont || "'Cormorant Garamond', serif";
          const textAlignVal = (cardText && cardText.style.textAlign) || 'center';

          ctx.fillStyle    = '#2a2a2a';
          ctx.font         = (fontSize * scale) + 'px ' + fontFam;
          ctx.textAlign    = textAlignVal === 'left' ? 'left' : textAlignVal === 'right' ? 'right' : 'center';
          ctx.textBaseline = 'alphabetic';

          const padding    = 11 * scale;
          const textAreaW  = cw - padding * 2;
          const lineH      = fontSize * scale * 1.2;
          const lines      = wrapTextCanvas(ctx, rawText, textAreaW);
          const totalH     = lines.length * lineH;

          let textX;
          if (textAlignVal === 'left')        textX = cx + padding;
          else if (textAlignVal === 'right')  textX = cx + cw - padding;
          else                                textX = cx + cw / 2;

          // Centro vertical: ascent ≈ 0.8 × lineH
          const startY = cy + (ch - totalH) / 2 + lineH * 0.8;
          for (let li = 0; li < lines.length; li++) {
            ctx.fillText(lines[li], textX, startY + li * lineH);
          }

          // 6. Stickers
          const stickerItems = stickerLayer
            ? stickerLayer.querySelectorAll('.mdc__card-sticker-item')
            : [];
          const stickerPromises = [];

          for (let si = 0; si < stickerItems.length; si++) {
            (function (item) {
              // Position relative to editor (same coordinate system as canvas)
              const itemRect = item.getBoundingClientRect();
              const iLeft = itemRect.left - editorRect.left;
              const iTop  = itemRect.top  - editorRect.top;
              const cssW  = itemRect.width  || 101;
              const cssH  = itemRect.height || 81;

              const imgEl  = item.querySelector('img');
              const spanEl = item.querySelector('span');

              if (imgEl && imgEl.src) {
                // Read natural dims NOW — the img is already rendered in the DOM
                // so these values are guaranteed correct before the async load
                const domNW = imgEl.naturalWidth;
                const domNH = imgEl.naturalHeight;
                stickerPromises.push(
                  loadCORSImage(imgEl.src).then(function (sImg) {
                    const nW  = domNW || sImg.naturalWidth  || cssW;
                    const nH  = domNH || sImg.naturalHeight || cssH;
                    const fit = Math.min(cssW / nW, cssH / nH);
                    const dw  = nW * fit;
                    const dh  = nH * fit;
                    const ox  = (cssW - dw) / 2;
                    const oy  = (cssH - dh) / 2;
                    ctx.drawImage(sImg,
                      (iLeft + ox) * scale,
                      (iTop  + oy) * scale,
                      dw * scale,
                      dh * scale
                    );
                  }).catch(function () {})
                );
              } else if (spanEl) {
                const emojiSize = Math.round(cssH * scale);
                ctx.save();
                ctx.font         = emojiSize + 'px sans-serif';
                ctx.textAlign    = 'left';
                ctx.textBaseline = 'top';
                ctx.fillStyle    = 'black';
                ctx.fillText(spanEl.textContent, iLeft * scale, iTop * scale);
                ctx.restore();
              }
            })(stickerItems[si]);
          }

          return Promise.all(stickerPromises).then(function () { return canvas; });
        });
      });
    }

    function downloadCard() {
       
      if (typeof AnalyticsPublisher !== 'undefined') {
        // eslint-disable-next-line no-undef
        AnalyticsPublisher.publish('click_element', {
          event: 'click_element',
          element_category: 'descargar',
          element_detail: 'dia_madre'
        });
      }

      [downloadBtn, dtDownloadBtn].forEach(function (b) {
        if (b) { b.disabled = true; b.classList.add('is-loading'); }
      });

      const ua        = navigator.userAgent;
      const isIOS     = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      const isAndroid = /Android/.test(ua);

      generateCardCanvas().then(function (canvas) {
        const filename = 'brownie-wallpaper-mothers-day.png';

        // iOS: Web Share API con File (sheet nativo para guardar en fotos)
        if (isIOS) {
          return new Promise(function (resolve, reject) {
            canvas.toBlob(function (blob) { blob ? resolve(blob) : reject(new Error('toBlob failed')); }, 'image/png');
          }).then(function (blob) {
            const file = new File([blob], filename, { type: 'image/png' });
            if (navigator.canShare && navigator.canShare({ files: [file] })) {
              return navigator.share({ files: [file], title: filename });
            }
          });
        }

        // Android: data URI con a.download
        if (isAndroid) {
          const a = document.createElement('a');
          a.href     = canvas.toDataURL('image/png');
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          return;
        }

        // Desktop: descarga directa con blob URL
        return new Promise(function (resolve, reject) {
          canvas.toBlob(function (blob) { blob ? resolve(blob) : reject(new Error('toBlob failed')); }, 'image/png');
        }).then(function (blob) {
          const url = URL.createObjectURL(blob);
          const a   = document.createElement('a');
          a.href     = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        });
      }).catch(function (err) {
        console.error('[MDC] Error generando imagen:', err);
      }).finally(function () {
        [downloadBtn, dtDownloadBtn].forEach(function (b) {
          if (b) { b.disabled = false; b.classList.remove('is-loading'); }
        });
      });
    }

    if (downloadBtn)   downloadBtn.addEventListener('click',   downloadCard);
    if (dtDownloadBtn) dtDownloadBtn.addEventListener('click', downloadCard);

    // ── INIT ─────────────────────────────────────────────────────────────────
    if (panels.sticker) panels.sticker.classList.remove('is-open');
    if (panels.voice)   panels.voice.classList.remove('is-open');
    setVoiceState('idle');
  };
})();
